<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-center">
        <v-flex xs12>
          <h3 class="text-center"><small>Professional Wallet</small> Add Entry <small>{{ professional.name }}</small></h3>
        </v-flex>
        <v-flex xs12 md6 sm8>
          <v-card>
            <v-card-title class="py-0">
              <v-spacer></v-spacer>
              <p><small>Balance:</small> {{ balance }}</p>
            </v-card-title>
            <v-card-text>
              <form @submit.prevent="formSubmitted">
                <v-text-field label="REF" required="required" minLength="10" v-model="entry.ref" autofocus :error-messages="errors.ref" :rules="[form_rules.required]"></v-text-field>
                <v-text-field label="Description" v-model="entry.description" placeholder="Optional" :error-messages="errors.description"></v-text-field>
                <v-text-field label="Debit Amount" placeholder="Will add to the account." hint="Will add to the account." v-model="entry.debit" type="number" step="0.01" min="0" :error-messages="errors.debit" :required="!entry.credit" :readonly="!!entry.credit" :rules="!entry.credit ? [form_rules.required] : []"></v-text-field>
                <v-text-field label="Credit Amount" placeholder="Will substract from the account. e.g. Payout" hint="Will substract from the account. e.g. Payout" :required="!entry.debit" :readonly="!!entry.debit" v-model="entry.credit" type="number" step="0.01" min="0" :error-messages="errors.credit" :rules="!entry.debit ? [form_rules.required] : []"></v-text-field>
                <v-btn small color="primary" type="submit" class="pull-right" :loading="loading">
                  <v-icon left>{{ icons.create }}</v-icon>
                  Submit
                </v-btn>
                <v-btn small @click="goTo(`/professionals/${professional.id}/wallets`)" title="Cancel">Cancel</v-btn>
              </form>
            </v-card-text>
            <v-card-actions class="py-0">
              <v-spacer></v-spacer>
              <span class="text-muted">You should input either credit or debit, BUT never both.</span>
            </v-card-actions>
          </v-card>
          <confirm-password ref="passwordConfirmation" @confirmed="SaveEntry(entry)" :instant="instant"></confirm-password>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'
  const ConfirmPassword = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/ConfirmsPassword')

  export default {
    name: 'CreateWalletEntry',
    layout,
    props: [
      'professional',
      'balance',
      'errors'
    ],
    components: {
      ConfirmPassword
    },
    metaInfo () {
      return {
        title: 'Professional Wallet | Add Entry | ' + this.professional.name,
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        entry: {},
        loading: false,
        instant: false,
      }
    },
    methods: {
      SaveEntry (entry) {
        this.$inertia.post(`/professionals/${this.professional.id}/wallets`, entry, {
          preserveScroll: true,
          preserveState: true,
          onBefore: () => this.loading = true,
          onFinish: () => this.loading = false,
        })
      },
      formSubmitted () {
        swal({
          title: 'Add to the account?',
          text: this.professional.name,
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'red',
          confirmButtonText:'Ok',
          closeOnConfirm: true,
          showLoaderOnConfirm: false,
        },
        function () {
          this.instant = true
        }.bind(this))
      }
    },
  }
</script>
